import React, { useEffect, useState } from "react";
import "./HealthInformationManager.css";
import closeIcon from "../../../common/assets/images/modal-close-icon.png";
import Select from "react-select";
import {
  getAssignmentUserOptions,
  getHealthInformationManagerQueuesData,
  getHealthInformationManagerUsersData,
  queueOptions,
  usersOptions,
} from "./redux/HealthInformationManagerSlicer";
import { getAssignmentOptions } from "./redux/HealthInformationManagerSlicer";

import { useDispatch, useSelector } from "react-redux";
import {
  episodeAssignmentCodeWorkflow,
  updateAssignmentFilters,
} from "./redux/HealthInformationManagerSlicer";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { fetchReportData } from "../Reports/redux/ReportsSlice";
const WorkflowAudiAssignModal = ({
  isAllEpisodesSelected,
  selectedRecord,
  setWorkflowHimsAssginModal,
  selectedHimEpisodes,
  uncheckedIds,
}) => {
  const dispatch = useDispatch();
  const {
    coderFilterOptions: { data: usersData },
    queueFilterOptions: { data: queueData },
  } = useSelector((state) => state.healthInsuranceManager);
  const { episodeAssignmentPayload } = useSelector(
    (state) => state.healthInsuranceManager,
  );
  const { assignmentOptions, assignmentUserOptions } = useSelector(
    (state) => state.healthInsuranceManager,
  );
  const {
    episodeAssignmentLoading,
    episodeAssignmentResponse,
    episodeAssignmentError,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInformationManagerAssignment,
  );
  const filtersPayload = useSelector(
    (state) =>
      state.healthInsuranceManager.healthInformationManagerEpisodesPayload,
  );
  const storedRole = sessionStorage.getItem("workspaceRole");
  const [userPage, setUserPage] = useState(1);
  const [queuePage, setQueuePage] = useState(1);
  const [showWarningDisableConfirmbtn, setShowWarningDisableConfirmbtn] =
    useState(false);

  const queueOptions =
    storedRole === "auditor"
      ? assignmentOptions?.queues?.auditor_queue?.map((q) => ({
          label: q.queue_name,
          value: q.queue_id,
        })) || []
      : assignmentOptions?.queues?.coder_queue?.map((q) => ({
          label: q.queue_name,
          value: q.queue_id,
        })) || [];

  const coderOptions =
    storedRole === "coder"
      ? assignmentUserOptions.users.coders.map((c) => ({
          label: c.user_name,
          value: c.user_id,
        }))
      : assignmentUserOptions.users.auditors.map((c) => ({
          label: c.user_name,
          value: c.user_id,
        }));

  const isPrefillReady = !assignmentOptions.loading;

  const hasNullURN = filtersPayload.ur_number?.includes(null);
  const hasNullLOS = filtersPayload.los_op === null;

  const finalFilters = {
    ...filtersPayload,
    no_mrn: hasNullURN ? true : false,
    no_los: hasNullLOS ? true : false,

    // clean nulls so backend doesn’t get them
    ur_number: hasNullURN
      ? filtersPayload.ur_number.filter((v) => v !== null)
      : filtersPayload.ur_number,

    los_op: hasNullLOS ? "" : filtersPayload.los_op,
  };

  useEffect(() => {
    dispatch(
      getAssignmentOptions({
        queue_type: storedRole,
        page_number: 1,
        limit: 10,
      }),
    );
    dispatch(
      getAssignmentUserOptions({
        user_type: storedRole,
        page_number: 1,
        limit: 10,
      }),
    );
    setUserPage(1);
    setQueuePage(1);
  }, []);

  useEffect(() => {
    if (!selectedRecord || Object.keys(selectedRecord).length === 0) return;

    if (selectedHimEpisodes?.length > 1) {
      dispatch(
        updateAssignmentFilters({
          // assignmentType: null,
          // mainQueueType: null,
          queue_ids: [],
          // user_id: null,
        }),
      );
      return;
    }

    if (assignmentOptions.loading) return;

    const toNumber = (val) => (val ? Number(val) : null);

    if (selectedRecord.assigned_user_ids) {
      dispatch(
        updateAssignmentFilters({
          // assignmentType: "CODER",
          user_id: toNumber(selectedRecord.assigned_user_ids),
          // mainQueueType: null,
          queue_ids: [],
        }),
      );
      return;
    } else if (
      selectedRecord.assigned_user_ids &&
      selectedRecord.assigned_user_ids !== "Unassigned"
    ) {
      // const foundCoder = assignmentUserOptions.users.coders.find(
      //   c => c.user_name?.toLowerCase() === selectedRecord.assigned_user?.toLowerCase()
      // );
      // if (foundCoder) {
      //   dispatch(updateAssignmentFilters({
      //     assignmentType: "CODER",
      //     mainQueueType: null,
      //   }));
      //   return;
      // }
    }

    if (selectedRecord.queue && selectedRecord.queue.length > 0) {
      const extractedIds = selectedRecord.queue.map((q) =>
        toNumber(q.queue_ids),
      );

      const backendQueueType = selectedRecord.queue[0]?.queue_type;

      if (backendQueueType) {
        const queueTypeMap = {
          coder_queue: "coder-queue",
          auditor_queue: "auditor-queue",
          coding_support_queue: "coding-support",
        };

        const frontendQueueType = queueTypeMap[backendQueueType];

        if (frontendQueueType && assignmentOptions.queues[frontendQueueType]) {
          dispatch(
            updateAssignmentFilters({
              // assignmentType: "QUEUE",
              // mainQueueType: frontendQueueType,
              queue_ids: extractedIds,
              user_id: null,
            }),
          );
          return;
        }
      }

      let foundQueueType = null;

      Object.entries(assignmentOptions.queues).forEach(
        ([queueType, queues]) => {
          if (queues && queues.length > 0) {
            const hasMatch = queues.some((queue) =>
              extractedIds.some((id) => Number(id) === Number(queue.queue_id)),
            );

            if (hasMatch) {
              foundQueueType = queueType;
            }
          }
        },
      );

      if (foundQueueType) {
        dispatch(
          updateAssignmentFilters({
            // assignmentType: "QUEUE",
            // mainQueueType: foundQueueType,
            queue_ids: extractedIds,
            user_id: null,
          }),
        );
      }
    }
  }, [
    selectedRecord,
    assignmentOptions.loading,
    assignmentUserOptions.users.coders,
    assignmentOptions.queues,
    selectedHimEpisodes?.length,
  ]);

  useEffect(() => {
    return () => {
      dispatch(updateAssignmentFilters(episodeAssignmentPayload));
    };
  }, []);

  const filterQueueNames = (filtersPayload.queue || [])
    .map(
      (id) =>
        queueData.find((q) => String(q.queue_id) === String(id))?.queue_name,
    )
    .filter(Boolean);

  const confirmAssgineHanlder = () => {
    if (
      episodeAssignmentPayload?.queue_ids?.length === 0 &&
      !episodeAssignmentPayload?.user_id
    ) {
      setShowWarningDisableConfirmbtn(true);
    }

    const payload = {
      hcp_lines: isAllEpisodesSelected
        ? []
        : selectedHimEpisodes.map((e) => e.hcp_line_id),
      select_all: isAllEpisodesSelected,
      unchecked_ids: uncheckedIds,
      is_flagged: episodeAssignmentPayload.is_flagged,
      user_id: episodeAssignmentPayload.user_id || null,
      queue_ids: episodeAssignmentPayload.queue_ids || [],
      user_queue_ids: episodeAssignmentPayload.user_queue_ids || [],
      filters: {
        ...finalFilters,
        queue: filterQueueNames,
        screen_type: storedRole,
      },
    };

    if (
      (storedRole === "coder" &&
        (episodeAssignmentPayload?.queue_ids?.length > 0 ||
          (episodeAssignmentPayload?.user_id != null &&
            episodeAssignmentPayload?.user_queue_ids?.length > 0))) ||
      (storedRole === "auditor" &&
        episodeAssignmentPayload?.queue_ids?.length > 0) ||
      episodeAssignmentPayload?.user_id != null
    ) {
      dispatch(episodeAssignmentCodeWorkflow(payload))
      .unwrap()
  .then(() => {
    dispatch(fetchReportData({
      pageNumber: 1,
      selectedFilters: {},
    }));

      
        dispatch(getHealthInformationManagerQueuesData({
        screen_type: storedRole === "coder" ? "U" : "AU",
        }));
        dispatch(
          getHealthInformationManagerUsersData({
            // user_type: storedRole,
            screen_type: storedRole === "coder" ? "U" : "AU",
            page_number: 1,
            limit: 10,
          }));
          setWorkflowHimsAssginModal(false);

      }, 300)
        .catch((err) => {

     const errorMessage =
      typeof err === "string"
        ? err
        : err?.error || err?.message || "Failed to Assign";

    toast.error(errorMessage); 
  });
      // toast.success("Episodes Assigned Successfully")
    }
  };

  const handleScroll = (type) => {
    if (type === "USER") {
      if (assignmentUserOptions.loading || !assignmentUserOptions.has_more)
        return;

      const nextPage = userPage + 1;

      dispatch(
        getAssignmentUserOptions({
          user_type: storedRole,
          page_number: nextPage,
          limit: 10,
        }),
      );

      setUserPage(nextPage);
    }

    if (type === "QUEUE") {
      if (assignmentOptions.loading || !assignmentOptions.has_more) return;

      const nextPage = queuePage + 1;

      dispatch(
        getAssignmentOptions({
          queue_type: storedRole,
          page_number: nextPage,
          limit: 10,
        }),
      );

      setQueuePage(nextPage);
    }
  };

  const isConfirmDisabled =
  storedRole === "auditor"
    ? (
        !episodeAssignmentPayload?.user_id ||
        !episodeAssignmentPayload?.user_queue_ids?.length
      )
    : (
        !episodeAssignmentPayload?.user_id &&
        !episodeAssignmentPayload?.queue_ids?.length
      );
  return (
    <div>
      <div className="workflow-him-assign-modal-overlay-fade">
        <div className="workflow-him-assign-modal-container">
          <div className="workflow-him-assign-header">
            <div>
              <p className="workflow-him-assign-header-text">
                {storedRole === "coder"
  ? "Assign Episodes to Coder"
  : storedRole === "auditor"
  ? "Assign Episodes for Auditor"
  : "Assign Episodes"}
              </p>
              <p className="workflow-him-assign-sub-header-text">
                Please select auditor, queue or both:
              </p>
            </div>
            <span onClick={() => setWorkflowHimsAssginModal(false)}>
              <img src={closeIcon} />
            </span>
          </div>
          {console.log(queueOptions, "queueOptions", episodeAssignmentPayload)}
          <div className="workflow-him-assign-body">
            <div className="workflow-him-assign-container">
              <label className="workflow-him-assign-label">Queue</label>
              <Select
                style={{ marginTop: "10px" }}
                onMenuScrollToBottom={() => handleScroll("QUEUE")}
                isMulti={storedRole === "auditor"}
                options={queueOptions}
                placeholder="Select queue"
                // value={queueOptions.filter(q =>
                //   episodeAssignmentPayload.queue_ids.some(
                //     id => Number(id) === Number(q.value)
                //   )
                // )}
                value={queueOptions.filter((q) => {
                  const source =
                    storedRole === "auditor" &&
                    episodeAssignmentPayload?.user_id != null
                      ? episodeAssignmentPayload.user_queue_ids
                      : episodeAssignmentPayload.queue_ids;
                  return source?.some((id) => Number(id) === Number(q.value));
                })}
                onChange={(val) => {
                  const values = Array.isArray(val)
                    ? val.map((v) => Number(v.value))
                    : val
                      ? [Number(val.value)]
                      : [];
                  dispatch(
                    updateAssignmentFilters({
                      queue_ids:
                        storedRole === "auditor" &&
                        episodeAssignmentPayload?.user_id != null
                          ? []
                          : values,
                      user_id:
                        storedRole === "coder"
                          ? null
                          : episodeAssignmentPayload?.user_id,
                      user_queue_ids:
                        storedRole === "auditor" &&
                        episodeAssignmentPayload?.user_id != null
                          ? values
                          : [],
                    }),
                  );
                  setShowWarningDisableConfirmbtn(false);
                }}
              />
            </div>
            {storedRole === "auditor" && episodeAssignmentPayload.user_id ? (
              ""
            ) : (
              <p className="workflow-him-assign-divider">OR</p>
            )}
            <div
              className={
                storedRole === "auditor" && episodeAssignmentPayload?.user_id
                  ? "workflow-him-assign-container"
                  : ""
              }
            >
              <label className="workflow-him-assign-label">
                {storedRole === "coder" ? "Coder" : "Auditor"}
              </label>
              <Select
                // isDisabled={!isPrefillReady}
                onMenuScrollToBottom={() => handleScroll("USER")}
                options={coderOptions}
                placeholder={storedRole === "coder" ? "Individual Coder" : "Select auditor"}
                value={
                  coderOptions.find(
                    (c) =>
                      Number(c.value) ===
                      Number(episodeAssignmentPayload?.user_id),
                  ) || null
                }
                  onInputChange={(inputValue) => {
            dispatch(
             getAssignmentUserOptions({
             user_type: storedRole,
             page_number: 1,
              limit: 100,
             search: inputValue,
           }),
         );
         }}
                onChange={(opt) => {
                  dispatch(
                    updateAssignmentFilters({
                      queue_ids: [],
                      user_id: opt ? opt.value : null,
                      user_queue_ids: episodeAssignmentPayload.user_queue_ids,
                    }),
                  );
                  setShowWarningDisableConfirmbtn(false);
                }}
              />
              {storedRole === "auditor" &&
                episodeAssignmentPayload?.user_id != null &&
                !episodeAssignmentPayload?.user_queue_ids?.length && (
                  <span style={{ fontSize: "14px" }}>
                    ⚠️ Audit queues is required for auditor assignment.
                  </span>
                )}
            </div>

            {/* {storedRole === "auditor" && episodeAssignmentPayload.user_id &&  
            (<div className="workflow-him-assign-container">
              <label className="workflow-him-assign-label">Queue</label>
                <Select
                  style={{ marginTop: "10px" }}
                  onMenuScrollToBottom={() => handleScroll("QUEUE")}
                  isMulti
                  options={queueOptions}
                  placeholder="Select queue"
                  value={queueOptions.filter(q =>
                    episodeAssignmentPayload.user_queue_ids.some(
                      id => Number(id) === Number(q.value)
                    )
                  )}
                  onChange={(val) => {
                    const values = Array.isArray(val)
                      ? val.map(v => Number(v.value))
                      : val ? [Number(val.value)] : [];
                    
                    dispatch(updateAssignmentFilters({
                      queue_ids: [],
                      user_id: episodeAssignmentPayload.user_id,
                      user_queue_ids: values,
                    }));
                  }}
                />
            </div>)
            } */}
            <div>
              <p className="workflow-him-assign-label-section">
                <input
                  type="checkbox"
                  checked={episodeAssignmentPayload.is_flagged}
                  onChange={(e) => {
                    dispatch(
                      updateAssignmentFilters({
                        is_flagged: e.target.checked,
                      }),
                    );
                  }}
                />
                <label>Flag this episode as urgent</label>
              </p>
              {showWarningDisableConfirmbtn && (
                <p className="him-episodeAssignment-waring">
                  ⚠️ Please select at least an auditor or a queue
                </p>
              )}
            </div>
            <div className="workflow-him-assign-footer">
              <div className="workflow-him-assign-footer-btn-section">
                <button
                  className="workflow-him-assign-cancel-btn"
                  onClick={() => setWorkflowHimsAssginModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="workflow-him-assign-confirm-btn"
                  onClick={confirmAssgineHanlder}
                  disabled={showWarningDisableConfirmbtn}
                >
                  {episodeAssignmentLoading ? (
                    <span>
                      <Spinner size="sm"/>
                    </span>
                  ) : (
                    "Confirm assignment"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowAudiAssignModal;